export const pageInitialData = {
  pageLevelErrors: {},
  authorMode: false,
};
